import { useEffect, useState } from "react";

export const OFFER_TYPES = {
  percentage: "Percentage discount",
  fixed: "Fixed amount off",
  bogo: "Buy One Get One",
  combo: "Combo offer",
  free_gift: "Free gift",
  special_price: "Special price",
  custom: "Custom offer",
};

export const TERMS = {
  initial: "Initial activation (1 month)",
  initial_monthly: "Initial + monthly (2 months)",
  initial_six: "Initial + 6-month renewal (7 months)",
  initial_annual: "Initial + annual renewal (13 months)",
  monthly: "Monthly renewal",
  six: "6-month renewal (pay 5)",
  annual: "Annual renewal (pay 10)",
  custom: "Custom / trial validity",
};

export const money = (n, cur = "INR") =>
  n == null ? "" : new Intl.NumberFormat("en-IN", { style: "currency", currency: cur, maximumFractionDigits: 0 }).format(n);

export const fmtDate = (iso, tz = "Asia/Kolkata", withTime = true) =>
  !iso
    ? "—"
    : new Intl.DateTimeFormat("en-IN", {
        timeZone: tz,
        day: "2-digit",
        month: "short",
        year: "numeric",
        ...(withTime ? { hour: "2-digit", minute: "2-digit" } : {}),
      }).format(new Date(iso));

export const dist = (m) => (m == null ? null : m < 1000 ? `${Math.round(m)} m` : `${(m / 1000).toFixed(1)} km`);

export const offerText = (d) => (d.discount_pct ? `${d.discount_pct}% OFF` : d.offer_label || OFFER_TYPES[d.offer_type] || "Deal");

export function useCountdown(iso) {
  const [t, setT] = useState(Date.now());
  useEffect(() => {
    const i = setInterval(() => setT(Date.now()), 1000);
    return () => clearInterval(i);
  }, []);
  const ms = iso ? new Date(iso).getTime() - t : 0;
  if (ms <= 0) return { done: true, text: "Expired", ms: 0 };
  const s = Math.floor(ms / 1000);
  const h = Math.floor(s / 3600);
  const pad = (x) => String(x).padStart(2, "0");
  return { done: false, ms, text: `${pad(h)}:${pad(Math.floor((s % 3600) / 60))}:${pad(s % 60)}` };
}
